module.exports = __webpack_public_path__ + "static/media/subscribeGuide5_Jap.c15061d8.png";